import i18n from "../i18n";

export const formatDataNumber = (number: number): any => {
    if (number)
        return formatAbbreviatedNumber(number);
    else
        return 0
}

export const formatAbbreviatedNumber = (number: number): any => {
    if (i18n.language == "en-US") {
        if (number) {
            let numberFormat;

            if (number >= 1000000) {
                numberFormat = `${(Math.floor((number / 1000000) * 10) / 10).toFixed(1)}M`;
            } else if (number >= 1000) {
                numberFormat = `${(Math.floor((number / 1000) * 10) / 10).toFixed(1)}k`;
            } else {
                numberFormat = new Intl.NumberFormat(i18n.language).format(number);
            }

            return numberFormat;
        } else {
            return 0;
        }
    } else {
        if (number) {
            let numberFormat;

            if (number >= 1000000) {
                numberFormat = `${(Math.floor((number / 1000000) * 10) / 10).toFixed(1)}mi`;
            } else if (number >= 1000) {
                numberFormat = `${(Math.floor((number / 1000) * 10) / 10).toFixed(1)}mil`;
            } else {
                numberFormat = new Intl.NumberFormat(i18n.language).format(number);
            }

            return numberFormat;
        } else {
            return 0;
        }
    }
}
